// The "Exportlevél": an e-mail asking for an album's export, drafted in Gmail for the user to finish and send.

import {isPictureFileName, parseEventFolderName} from './naming';
import {EventInfo, getCoverFileName} from './eventInfo';

export const EXPORT_MAIL_RECIPIENT = 'spot-it@simonyi.bme.hu';
export const EXPORT_MAIL_BODY = 'Sziasztok!\n\n<valami kreatív helye>\nA tárgyban említett albumra szeretnék kérni egy exportot!\n\nKöszi,\n';

/**
 * The album an export is asked for, by its index in the path from the drive root down (-1 for an empty
 * path): the uppermost event folder, since sub-albums (at any depth) are exported together with it.
 * Falls back to the top-level folder when none of them follows the event folder convention.
 */
export function exportAlbumIndex(pathNames: string[]): number {
    const eventIndex = pathNames.findIndex((name) => parseEventFolderName(name));
    return eventIndex >= 0 ? eventIndex : pathNames.length > 0 ? 0 : -1;
}

/** Why an album with this info.json can't be exported yet: it needs a title and a picture as cover. */
export function exportInfoProblem(info: EventInfo): string | undefined {
    if (!info.title.trim()) return 'Az exportálandó album info.json-jában nincs cím.';
    const coverName = getCoverFileName(info.cover);
    if (!coverName) return 'Az exportálandó albumnak nincs borítóképe.';
    if (!isPictureFileName(coverName)) return 'Az exportálandó album borítóképének neve nem megfelelő.';
    return undefined;
}

export function exportMailSubject(albumName: string): string {
    return `[EXPORT] ${albumName}`;
}

export interface ComposeMail {
    /** The Google account to write from (its e-mail); Gmail's default account without it. */
    account?: string;
    to: string;
    subject: string;
    body: string;
}

/** A Gmail URL that opens a draft, in the given account, for the user to finish and send. */
export function gmailComposeUrl({account, to, subject, body}: ComposeMail): string {
    // Encoded by hand: URLSearchParams writes spaces as "+".
    const params: [string, string][] = [
        ...(account ? [['authuser', account] as [string, string]] : []),
        ['view', 'cm'],
        ['fs', '1'],
        ['to', to],
        ['su', subject],
        ['body', body],
    ];
    return 'https://mail.google.com/mail/?' + params.map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
}
